export default {
  header: {
    project: "Projet :",
    architecture: "Architecture :",
    provider: "Fournisseur :",
    file: {
      title: "Fichier",
      load: "Charger",
      save: "Sauvegarder",
      export: "Exporter"
    },
    versions: {
      title: "Versions",
      create: "Créer une version",
      viewHistory: "Voir l'historique",
      management: "Gestion des versions"
    },
    documentation: {
      title: "Documentation",
      generate: "Générer la documentation",
      markdown: "Markdown (.md)",
      html: "HTML (.html)"
    },
    fitView: "Ajuster la vue",
    fitViewTitle: "Ajuster la vue au canvas"
  },
  tabBar: {
    closeTab: "Fermer l'onglet",
    newArchitecture: "Nouvelle architecture",
    unsavedChanges: {
      title: "Modifications non sauvegardées",
      message: "Cette architecture contient des modifications non sauvegardées. Voulez-vous vraiment la fermer ?",
      cancel: "Annuler",
      closeWithoutSaving: "Fermer sans sauvegarder"
    }
  },
  versionHistory: {
    title: "Historique des versions",
    empty: {
      title: "Aucune version sauvegardée",
      description: 'Utilisez le bouton "Créer une version" pour sauvegarder l\'état actuel'
    },
    buttons: {
      load: "Charger",
      loadTitle: "Charger cette version",
      exportTitle: "Exporter cette version",
      deleteTitle: "Supprimer cette version"
    },
    stats: {
      resources: "ressources",
      connections: "connexions"
    },
    confirmLoad: {
      message: 'Charger la version "{{version}}" ?\n\nCela remplacera l\'architecture actuelle.',
      success: '✅ Version "{{version}}" chargée avec succès !'
    },
    confirmDelete: {
      message: "Supprimer cette version ?\n\nCette action est irréversible.",
      success: "🗑️ Version supprimée avec succès !"
    }
  },
  cost: {
    title: "Coût Estimé",
    autoUpdateTooltip: "Mise à jour automatique",
    empty: "Ajoutez des ressources pour voir l'estimation",
    perMonth: "/mois",
    perHour: "/heure",
    resourcesEstimated: "{{count}} ressource estimée",
    resourcesEstimated_plural: "{{count}} ressources estimées",
    resourcesUnsupported: "{{count}} ressource non supportée",
    resourcesUnsupported_plural: "{{count}} ressources non supportées",
    buttons: {
      detailedAnalysis: "Analyse Détaillée",
      refresh: "Actualiser",
      save: "Sauvegarder",
      saving: "Sauvegarde...",
      showForecasts: "Afficher prévisions",
      hideForecasts: "Masquer prévisions",
      exportPDF: "PDF",
      exportExcel: "Excel"
    },
    budgetAlert: "Attention: {{percent}}% du budget utilisé",
    forecasts: {
      title: "Prévisions de coûts:",
      quarterly: "3 mois:",
      semiAnnual: "6 mois:",
      annual: "12 mois:"
    },
    breakdown: {
      title: "Détail par ressource:",
      unsupported: "Ressources non supportées ({{count}})"
    },
    updatedAt: "Mis à jour: {{date}}",
    messages: {
      savingSuccess: "Estimation sauvegardée avec succès!",
      savingError: "Erreur lors de la sauvegarde de l'estimation",
      exportPDFError: "Erreur lors de l'export PDF",
      exportExcelError: "Erreur lors de l'export Excel"
    }
  },
  analysis: {
    title: "Analyse des Coûts",
    subtitle: "Analyse détaillée de votre architecture cloud",
    kpis: {
      estimatedCost: "COÛT ESTIMÉ",
      budgetUsage: "UTILISATION BUDGET",
      forecast: "PRÉVISION",
      potentialSavings: "ÉCONOMIES POTENTIELLES",
      vsBudget: "vs budget",
      recommendations: "recommandations"
    },
    tabs: {
      overview: "Vue d'ensemble",
      breakdown: "Détail",
      chart: "Graphiques",
      optimization: "Optimisation"
    },
    overview: {
      resources: "Ressources",
      resourcesEstimated: "Ressources estimées",
      unsupported: "non supportées",
      optimization: "Optimisation",
      loading: "Chargement...",
      possibleSavings: "Économies possibles",
      noData: "Aucune donnée disponible"
    },
    optimization: {
      analyzing: "Analyse des optimisations possibles...",
      noRecommendations: "Aucune recommandation disponible",
      noRecommendationsDescription: "Ajoutez des ressources pour obtenir des recommandations d'optimisation"
    }
  },
  sidebar: {
    searchPlaceholder: "Rechercher un composant...",
    loadingAzure: "Chargement des ressources Azure…",
    errorAzure: "Erreur backend Azure : {{error}}. (La liste ne s'affiche qu'avec le backend ou la whitelist)"
  },
  diagram: {
    save: {
      filenamePlaceholder: "nom-du-fichier",
      filenameTitle: "Nom du fichier (sans .json)",
      buttonTitle: "Enregistrer (choix du nom et du dossier)",
      button: "Enregistrer"
    },
    load: {
      buttonTitle: "Charger un diagramme (.json)",
      button: "Charger",
      invalidJson: "Fichier JSON invalide.",
      unexpectedStructure: "Structure JSON inattendue : 'nodes' et 'edges' requis."
    }
  },
  flowEditor: {
    toolbar: {
      save: "Sauvegarder",
      saveTitle: "Sauvegarder le diagramme",
      undo: "Annuler",
      undoTitle: "Annuler (Ctrl+Z)",
      redo: "Rétablir",
      redoTitle: "Rétablir (Ctrl+Y)",
      reset: "Réinitialiser",
      resetTitle: "Réinitialiser le canvas",
      resetConfirm: "⚠️ Êtes-vous sûr de vouloir réinitialiser le canvas ? Cette action est irréversible.",
      alignLeft: "Aligner à gauche",
      alignCenter: "Aligner au centre",
      alignRight: "Aligner à droite",
      addNote: "Ajouter une note",
      note: "Note",
      addGroup: "Ajouter un groupe",
      group: "Groupe",
      validation: "Validation",
      showValidation: "Afficher la validation",
      hideValidation: "Masquer la validation",
      variables: "Variables",
      showVariables: "Afficher les variables",
      hideVariables: "Masquer les variables"
    },
    contextMenu: {
      settings: "Paramètres",
      rename: "Renommer",
      duplicate: "Dupliquer",
      delete: "Supprimer"
    },
    defaults: {
      newNote: "Nouvelle note...",
      newGroup: "Nouveau Groupe"
    }
  },
  settingsPanel: {
    title: "Paramètres — {{title}}",
    defaultTitle: "Ressource",
    buttons: {
      expand: "Agrandir",
      expandTitle: "Agrandir / Paramètres à droite",
      close: "Fermer",
      save: "Enregistrer",
      clear: "Effacer"
    },
    search: {
      placeholder: "🔍 Rechercher un champ...",
      active: "Recherche : \"{{query}}\"",
      clear: "Effacer"
    },
    fields: {
      label: "Label",
      location: "Location",
      locationPlaceholder: "Ex: eastus, westeurope",
      locationDescription: "Région Azure où déployer la ressource",
      locationNone: "Pas de localisation (ressource globale)",
      name: "Nom",
      namePlaceholder: "Nom de la ressource",
      resourceGroup: "Resource Group",
      resourceGroupPlaceholder: "Nom du resource group",
      selectPlaceholder: "— choisir —",
      enterField: "Entrez {{field}}"
    },
    parameters: {
      title: "Paramètres",
      advanced: "⚙ Avancé",
      simple: "✓ Mode simple",
      estimation: "💰 Paramètres d'estimation",
      noEditable: "Aucun paramètre éditable.",
      requiredMark: "*"
    },
    messages: {
      loading: "Chargement…",
      basicMode: "<strong>Mode basique :</strong> Les paramètres avancés nécessitent le backend. Vous pouvez toujours modifier les paramètres de base.",
      basicModeConfig: "<strong>Mode basique :</strong> Configuration détaillée disponible quand le backend est connecté",
      loadedFromTerraform: "✓ Chargé depuis le schéma Terraform officiel"
    }
  },
  connectionSuggestions: {
    button: {
      title: "{{count}} suggestion de connexion",
      title_plural: "{{count}} suggestions de connexion",
      dismiss: "Masquer les suggestions"
    },
    drawer: {
      title: "Suggestions de Connexion",
      close: "Fermer",
      stats: {
        critical: "{{count}} Critique",
        critical_plural: "{{count}} Critiques",
        recommended: "{{count}} Recommandé",
        recommended_plural: "{{count}} Recommandés",
        total: "{{count}} Total"
      },
      noSuggestions: {
        title: "Connexion Valide !",
        message: "Cette connexion ne nécessite aucune configuration supplémentaire."
      },
      suggestion: {
        resourceType: "Type de ressource:",
        properties: "Propriétés pré-configurées:",
        createButton: "Créer la ressource",
        configureManually: "Configurer manuellement",
        manualWarning: "⚠️ Cette suggestion nécessite une configuration manuelle des propriétés"
      }
    }
  },
  validation: {
    panel: {
      success: "Validation réussie",
      noProblem: "Aucun problème détecté",
      title: "Validation",
      problems: "{{count}} problème détecté",
      problems_plural: "{{count}} problèmes détectés",
      minimize: "Minimiser",
      close: "Fermer",
      allCorrect: "Toutes les ressources sont correctement configurées"
    },
    minimized: {
      noProblem: "Aucun problème",
      problems: "{{count}} problème",
      problems_plural: "{{count}} problèmes"
    },
    groups: {
      errors: "Erreurs",
      warnings: "Avertissements",
      info: "Informations",
      field: "Champ:"
    }
  },
  patterns: {
    title: "Patterns",
    library: "Bibliothèque",
    openTitle: "Ouvrir la bibliothèque de patterns - Modèles d'architectures réutilisables",
    closeTitle: "Fermer la bibliothèque de patterns",
    resourceCount: "{{count}} ressources"
  },
  rightDrawer: {
    ariaLabel: "Panneau paramètres (dock)"
  },
  fieldSuggestions: {
    showSuggestions: "Afficher les suggestions",
    suggestionCount: "{{count}} suggestion",
    suggestionCount_plural: "{{count}} suggestions"
  },
  groupNode: {
    colors: {
      blue: "Bleu",
      green: "Vert",
      pink: "Rose",
      orange: "Orange",
      purple: "Violet",
      gray: "Gris"
    },
    edit: "Modifier",
    delete: "Supprimer",
    dropHint: "Glissez des ressources ici pour les grouper"
  },
  canvasWrapper: {
    messages: {
      projectLoaded: "✅ Projet chargé avec succès !",
      invalidJson: "❌ Fichier JSON invalide.",
      architectureSaved: "✅ Architecture sauvegardée avec succès dans le cloud (ADLS) !",
      projectSavedLocally: "💾 Projet sauvegardé localement (créez une architecture pour la sauvegarde cloud)",
      documentationGenerated: "📄 Documentation générée avec succès (Markdown et HTML) !",
      saveError: "❌ Erreur lors de la sauvegarde: {{error}}",
      versionCreated: "🔖 Version \"{{version}}\" créée avec succès !"
    },
    prompts: {
      versionName: "Nom de la version:",
      versionDescription: "Description de cette version:"
    },
    defaults: {
      architecture: "Architecture",
      architectureCloud: "Architecture Cloud",
      project: "Projet"
    }
  },
  connectionSuggestionsPanel: {
    title: "Suggestions de connexion",
    close: "Fermer",
    stats: {
      critical: "critique",
      critical_plural: "critiques",
      recommended: "recommandé",
      recommended_plural: "recommandés"
    },
    noConfiguration: "Cette connexion ne nécessite aucune configuration supplémentaire",
    resourceType: "Type de ressource:",
    preConfiguredProperties: "Propriétés pré-configurées:",
    createResource: "Créer la ressource",
    manualConfiguration: "Cette suggestion nécessite une configuration manuelle",
    configureManually: "Configurer manuellement"
  },
  blockEditor: {
    keyPlaceholder: "clé",
    valuePlaceholder: "valeur",
    noAttributes: "Aucun attribut dans ce bloc.",
    addButton: "Ajouter",
    removeButton: "Supprimer",
    selectPlaceholder: "— choisir —"
  },
  annotationNode: {
    save: "Enregistrer",
    cancel: "Annuler",
    placeholder: "Cliquez pour ajouter une note..."
  },
  diagramSettings: {
    editParameters: "Modifier les paramètres..."
  },
  variables: {
    title: "Variables & Paramètres",
    parameters: "paramètres",
    internal: "internes",
    minimized: "{{count}} variables",
    refresh: "Actualiser",
    minimize: "Minimiser",
    close: "Fermer",
    search: "Rechercher des variables...",
    filterAll: "Tous",
    filterParameters: "Paramètres",
    filterVariables: "Variables",
    add: "Ajouter",
    loading: "Chargement...",
    retry: "Réessayer",
    noResults: "Aucune variable ne correspond à votre recherche",
    empty: "Aucune variable définie",
    createFirst: "Créer votre première variable",
    confirmDelete: "Êtes-vous sûr de vouloir supprimer cette variable ?",
    edit: "Modifier",
    delete: "Supprimer",
    param: "param",
    var: "var",
    sensitive: "sensible",
    default: "Défaut",
    rules: "Règles",
    editTitle: "Modifier la variable",
    createTitle: "Créer une variable",
    basicInfo: "Informations de base",
    name: "Nom",
    displayName: "Nom d'affichage",
    description: "Description",
    descriptionPlaceholder: "Décrivez à quoi sert cette variable...",
    scope: "Portée",
    scopeParameter: "Paramètre (exposé)",
    scopeVariable: "Variable (interne)",
    scopeParameterHelp: "Les utilisateurs peuvent surcharger cette valeur",
    scopeVariableHelp: "Valeur interne, auto-calculée",
    type: "Type",
    category: "Catégorie",
    order: "Ordre",
    isSensitive: "Valeur sensible (masquée dans les logs)",
    defaultValue: "Valeur par défaut",
    staticValue: "Valeur statique",
    expression: "Expression",
    expressionHelp: "Utilisez des expressions Terraform comme ${resource.attribute}",
    validation: "Règles de validation",
    required: "Requis",
    minValue: "Valeur min",
    maxValue: "Valeur max",
    minLength: "Longueur min",
    maxLength: "Longueur max",
    pattern: "Pattern (regex)",
    allowedValues: "Valeurs autorisées",
    addValue: "Ajouter une valeur...",
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement...",
    nameRequired: "Le nom est requis",
    nameFormat: "Le nom doit être en snake_case (minuscules, underscores, commence par une lettre)"
  }
};
